<div
  class="slide-panel__backdrop"
  [class.visible]="open"
  [class.slide-panel__backdrop--inline-desktop]="inlineOnDesktop"
  (click)="close()"
></div>

<aside
  class="slide-panel"
  [class.slide-panel--open]="open"
  [class.slide-panel--inline-desktop]="inlineOnDesktop"
  role="dialog"
  aria-modal="true"
  [attr.aria-hidden]="open ? null : true"
  [attr.aria-label]="title || null"
>
  <header class="slide-panel__header">
    <h2 class="slide-panel__title">{{ title }}</h2>
    <button
      mat-icon-button
      type="button"
      class="slide-panel__close"
      [attr.aria-label]="closeLabel"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="slide-panel__body">
    <ng-content></ng-content>
  </div>

  <footer class="slide-panel__footer">
    <ng-content select="[slidePanelFooter]"></ng-content>
  </footer>
</aside>
